
import { getPostcodeValidationStatus, getShippingPostcode, clearValue } from './local_storage';
import { showAutoCompletePostcodeSelector } from '../validator/PostcodeAutocompleteValidator';

export const clearPostcodeFromLocalStorage =
    ({ store }) => {
        const bust = getPostcodeValidationStatus();
        if (getShippingPostcode() && !bust && showAutoCompletePostcodeSelector(store)) {
            clearValue('shippingPostcode');
            clearValue('shippingState');
            clearValue('latLng');
        }
    }